import { useEffect } from 'react';

import { useOidcAccessToken } from '@axa-fr/react-oidc';

import { useAccessTokenStore } from '../store/useAccessTokenStore';

/**
 * A side effect hook that place the access token in the store.
 */
export function useRefreshAccessToken() {
  const { accessToken, accessTokenPayload } = useOidcAccessToken();
  const setValue = useAccessTokenStore((state) => state.setValue);

  useEffect(() => {
    setValue(accessToken, accessTokenPayload);
  }, [accessToken, accessTokenPayload, setValue]);
}
